<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col d-flex align-items-center">
        <h1 class="fs-4 fw-bold text-primary-color my-0">Entidade</h1>
      </div>
      <ng-template [ngxPermissionsOnly]="[perfilEnum.Administrador, perfilEnum.Validador]">
        <div class="col d-flex justify-content-sm-end align-items-center">
          <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill" (click)="novo()">
            Adicionar Entidade
          </button>
        </div>
      </ng-template>

    </div>

    <nz-divider class="m-0 p-0 mt-2 mb-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <div #entidadeList>
          <form [formGroup]="entidadeFilterForm" id="entidadeFilterForm" (ngSubmit)="pesquisar()">
            <div class="row row-cols-2 row-cols-md-3 g-4 mb-2">
              <div class="col-sm-4 form-group">
                <label for="razaoSocial" class="form-label">Nome/Nome Reduzido</label>
                <nz-input-group nzSize="large">
                  <input nz-input id="razaoSocial" formControlName="razaoSocial" placeholder="Nome ou Nome Reduzido" />
                </nz-input-group>
              </div>
              <div class="col form-group">
                <label for="cnpj" class="form-label">CNPJ</label>
                <nz-input-group nzSize="large">
                  <input nz-input id="cnpj" formControlName="cnpj" placeholder="CNPJ" mask="00.000.000/0000-00" />
                </nz-input-group>
              </div>
              <div class="col form-group">
                <label for="situacao" class="form-label">Situação</label>
                <nz-select formControlName="situacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeStatusEntidade"
                    *ngFor="let item of statusEntidade" />
                </nz-select>
              </div>
              <div class="col form-group">
                <label for="grupoEconomico" class="form-label">Grupo Econômico</label>
                <nz-select formControlName="grupoEconomico" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeGrupoEconomico"
                    *ngFor="let item of gruposEconomico" />
                </nz-select>
              </div>

              <div class="col form-group">
                <label for="tipoEntidade" class="form-label">Tipo de Entidade</label>
                <nz-select formControlName="tipoEntidade" nzPlaceHolder="-" nzSize="large" nzShowSearch nzServerSearch
                  [nzShowArrow]="false" [nzFilterOption]="nzFilterOption" nzSize="large" [nzAllowClear]="true"
                  nzMode="multiple">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoEntidade" *ngFor="let item of tiposEntidade" />
                </nz-select>
              </div>

              <ng-container *ngIf="mostrarSubTipoEntidade">
                <div class="col-sm-4 form-group">
                  <label for="subTipo" class="form-label">Sub Tipo</label>
                  <nz-select formControlName="subTipo" nzShowSearch nzAllowClear nzPlaceHolder="Selecione o Sub Tipo"
                    nzSize="large">
                    <nz-option *ngFor="let item of subTipoList" [nzValue]="item.id"
                      [nzLabel]="item.nomeSubTipoEntidade" />
                  </nz-select>
                </div>
              </ng-container>

              <ng-container *ngIf="mostrarCargo">
                <div class="col-sm-4 form-group">
                  <label for="cargo" class="form-label">Cargos</label>
                  <nz-select formControlName="cargo" nzShowSearch nzAllowClear nzPlaceHolder="Selecione o cargo"
                    nzSize="large">
                    <nz-option *ngFor="let item of cargoList" [nzValue]="item.id"
                      [nzLabel]="item.nomeCargoReferencia" />
                  </nz-select>
                </div>
              </ng-container>

              <div class="col form-group">
                <label for="entidadeSuperior" class="form-label">Entidade Superior</label>
                <nz-select formControlName="entidadeSuperior" nzShowSearch nzAllowClear nzPlaceHolder=" - "
                  nzSize="large">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeSuperiorList" />
                </nz-select>
              </div>

              <div class="col form-group">
                <label for="tipoOrgao" class="form-label">Tipo de Órgão</label>
                <nz-select formControlName="tipoOrgao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
                  [nzMode]="'multiple'">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoOrgao" *ngFor="let item of tiposOrgao" />
                </nz-select>
              </div>
              <div class="col-sm-3 form-group">
                <label for="tipoAssociacao" class="form-label">Tipo Associação</label>
                <nz-select formControlName="tipoAssociacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large">
                  <nz-option [nzValue]="item.codigo" [nzLabel]="item.nome" *ngFor="let item of tipoAssociadaList" />
                </nz-select>
              </div>
              <div class="col form-group">
                <label for="grupoAtualizacao" class="form-label">Grupo de Atualização</label>
                <nz-select formControlName="grupoAtualizacao" nzShowSearch nzAllowClear nzPlaceHolder="-" nzSize="large"
                  [nzMode]="'multiple'">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeGrupoAtualizacao"
                    *ngFor="let item of gruposAtualizacao" />
                </nz-select>
              </div>

              <div class="col form-group">
                <label for="entidadePertenceId" class="form-label">Pertence a:</label>
                <nz-select formControlName="entidadePertenceId" nzShowSearch nzAllowClear nzPlaceHolder="Pertence a"
                  nzSize="large">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia"
                    *ngFor="let item of entidadesPertenceList" />
                </nz-select>
              </div>

              <div class="col form-group">
                <label for="email" class="form-label">E-mail</label>
                <nz-input-group nzSize="large">
                  <input nz-input id="email" formControlName="email" placeholder="E-mail" />
                </nz-input-group>
              </div>
            </div>

            <div class="form-group d-flex justify-content-end ml-3">
              <button nz-button type="submit" nzType="primary" [nzSize]="size" class="rounded-pill mt-4 me-3"
                form="entidadeFilterForm">
                Pesquisar
              </button>
              <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4 me-3"
                (click)="resetForm()">
                Limpar
              </button>
              <!-- <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4" (click)="exportar()">
              Exportar
            </button> -->
            </div>
          </form>

          <nz-divider class="m-0 p-0 mt-4"></nz-divider>

          <div class="d-flex flex-column page-content border border-radius w-100" id="entidadeList">
            <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
              [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
              [nzLoading]="loadingTabela"
              [nzScroll]="{ x: 'max-content' }">
              <thead>
                <tr>
                  <th class="sortable-header" nzColumnKey="nomeRazaoSocial" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('nomeRazaoSocial')"
                    (mousedown)="rememberShift($event, 'nomeRazaoSocial')"
                    (nzSortOrderChange)="onColumnSort('nomeRazaoSocial', $event)"
                    nz-tooltip
                    nzTooltipTitle="Shift + clique para ordenar por mais de uma coluna">
                    Nome
                    <span class="sort-priority" *ngIf="sortPriorityOf('nomeRazaoSocial') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="nomeFantasia" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('nomeFantasia')"
                    (mousedown)="rememberShift($event, 'nomeFantasia')"
                    (nzSortOrderChange)="onColumnSort('nomeFantasia', $event)">
                    Nome Reduzido
                    <span class="sort-priority" *ngIf="sortPriorityOf('nomeFantasia') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="entidadePertence" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="130px"
                    [nzSortOrder]="sortOrderOf('entidadePertence')"
                    (mousedown)="rememberShift($event, 'entidadePertence')"
                    (nzSortOrderChange)="onColumnSort('entidadePertence', $event)">
                    Pertence a:
                    <span class="sort-priority" *ngIf="sortPriorityOf('entidadePertence') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="entidadesSuperiores" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('entidadesSuperiores')"
                    (mousedown)="rememberShift($event, 'entidadesSuperiores')"
                    (nzSortOrderChange)="onColumnSort('entidadesSuperiores', $event)">
                    Entidades Superiores
                    <span class="sort-priority" *ngIf="sortPriorityOf('entidadesSuperiores') as prioridade">{{ prioridade }}</span>
                  </th>
                   <th class="sortable-header" nzColumnKey="tipoEntidade" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('tipoEntidade')"
                    (mousedown)="rememberShift($event, 'tipoEntidade')"
                    (nzSortOrderChange)="onColumnSort('tipoEntidade', $event)">
                    Tipo de Entidade
                    <span class="sort-priority" *ngIf="sortPriorityOf('tipoEntidade') as prioridade">{{ prioridade }}</span>
                  </th>
                   <th class="sortable-header" nzColumnKey="subtipoEntidade" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="250px"
                    [nzSortOrder]="sortOrderOf('subtipoEntidade')"
                    (mousedown)="rememberShift($event, 'subtipoEntidade')"
                    (nzSortOrderChange)="onColumnSort('subtipoEntidade', $event)">
                    Subtipo de Entidade
                    <span class="sort-priority" *ngIf="sortPriorityOf('subtipoEntidade') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="cnpj" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('cnpj')"
                    (mousedown)="rememberShift($event, 'cnpj')"
                    (nzSortOrderChange)="onColumnSort('cnpj', $event)">
                    CNPJ
                    <span class="sort-priority" *ngIf="sortPriorityOf('cnpj') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="email" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="150px"
                    [nzSortOrder]="sortOrderOf('email')"
                    (mousedown)="rememberShift($event, 'email')"
                    (nzSortOrderChange)="onColumnSort('email', $event)">
                    E-MAIL
                    <span class="sort-priority" *ngIf="sortPriorityOf('email') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="statusEntidade" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="80px"
                    [nzSortOrder]="sortOrderOf('statusEntidade')"
                    (mousedown)="rememberShift($event, 'statusEntidade')"
                    (nzSortOrderChange)="onColumnSort('statusEntidade', $event)">
                    Situação
                    <span class="sort-priority" *ngIf="sortPriorityOf('statusEntidade') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="dataUltimaAtualizacao" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="110px"
                    [nzSortOrder]="sortOrderOf('dataUltimaAtualizacao')"
                    (mousedown)="rememberShift($event, 'dataUltimaAtualizacao')"
                    (nzSortOrderChange)="onColumnSort('dataUltimaAtualizacao', $event)">
                    Atualizado em
                    <span class="sort-priority" *ngIf="sortPriorityOf('dataUltimaAtualizacao') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="sortable-header" nzColumnKey="excluido" nzShowSort [nzSortFn]="true" [nzSortPriority]="true" nzWidth="80px"
                    [nzSortOrder]="sortOrderOf('excluido')"
                    (mousedown)="rememberShift($event, 'excluido')"
                    (nzSortOrderChange)="onColumnSort('excluido', $event)">
                    Excluido
                    <span class="sort-priority" *ngIf="sortPriorityOf('excluido') as prioridade">{{ prioridade }}</span>
                  </th>
                  <th class="text-center" nzWidth="80px" [nzRight]="true">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="paginator?.paginaAtual">
                  <tr *ngFor="let item of dataSet" [class.text-danger]="statusInativo(item?.statusEntidade)">
                    <!-- <td>{{ item?.id }}</td> -->
                    <td>{{ item?.nomeRazaoSocial }}</td>
                    <td>{{ item?.nomeFantasia }}</td>
                    <td>{{ item?.entidadePertence }}</td>
                    <td>{{ item?.entidadesSuperiores}}</td>
                    <td>{{ item?.tipoEntidade }}</td>
                    <td>{{ item?.subtipoEntidade }}</td>
                    <td>{{ item?.cnpj | cnpj }}</td>
                    <td>{{ item?.email }}</td>
                    <!-- <td>{{ item?.entidadeSuperior }}</td> -->
                    <td>{{ item?.statusEntidade }}</td>
                    <td>{{ item?.dataUltimaAtualizacao }}</td>
                    <td>{{ item?.excluido ? "Sim" : "Não" }}</td>

                    <td class="text-center" [nzRight]="true">
                      <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                        <span nz-icon nzType="more" nzTheme="outline"></span>
                      </button>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                          <li nz-menu-item *ngIf="!item.excluido" type="button" (click)="editar(item)">
                            <a> Detalhes / Editar</a>
                          </li>
                          <ng-container *ngxPermissionsOnly="[perfilEnum.Administrador, perfilEnum.Validador]">
                            <li nz-menu-item *ngIf="item.excluido" type="button" (click)="filter(item, 'ATIVAR')">
                              <a>Reativar</a>
                            </li>
                            <li nz-menu-item *ngIf="!item.excluido" type="button" (click)="filter(item, 'INATIVAR')">
                              <a>Excluir</a>
                            </li>
                          </ng-container>
                        </ul>
                      </nz-dropdown-menu>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
            <ng-template #footerTemplate>
              <section class="d-flex justify-content-end w-100">
                <app-pagination [itemPorPagina]="10"></app-pagination>
              </section>
            </ng-template>
            <ng-template #semDadosTemplate>
              <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
                <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-end align-items-center mt-3">
          <ng-template *ngxPermissionsOnly="[perfilEnum.Administrador, perfilEnum.Validador]">
            <eds-popover class="menu-exportar-actions" targetClass="exportar-actions" position="bottom">
              <td class="text-center">
                <button nz-button nz-dropdown [nzDropdownMenu]="menu" nzType="primary" [nzSize]="size" nzShape="circle">
                  <span nz-icon nzType="download"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu></ul>
                </nz-dropdown-menu>
              </td>
            </eds-popover>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>
